import API from '../../../API/api';
import Cart from '../../stores/models/cart';
import {
    shippingOptionsComputeStarted,
    shippingOptionsComputeSuccess,
    shippingOptionsComputeFailed
} from '../../actions/http_request/product_mixed_stocks_shipping_options_compute_actions';
/**
 * @param cart
 * @returns {*}
 */
function shippingOptionsComputeRequest(cart) {
    'use strict';

    if (!(cart instanceof Cart)) {
        shippingOptionsComputeFailed();
        return null;
    }

    const data = {
        items: [],
        shippingAddress: {
            ...cart.shippingAddress
        }
    };

    if (null !== cart.shippingAddress.fsId) {
        data.shippingAddress.fsId = cart.shippingAddress.fsId;
    }

    cart.items.map((item) => {
        let cartItems = {
            productCode: item.productCode,
            stockType: item.stockType,
            itemStocks: [],
        };
        item.itemStocks.map((stock) => {
            cartItems.itemStocks.push(
                {
                    supplierStock: {idSupplierStock: stock.supplierStock.idSupplierStock},
                    qty: stock.qty
                }
            );
        });

        data.items.push(cartItems);
    });
    const payload = JSON.stringify(data);
    shippingOptionsComputeStarted();
    return API.POST({
        apiPath: '/api/v2/carts/availableshippingoptions/compute/',
        data: payload,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
    }).catch(() => {
        shippingOptionsComputeFailed();
    }).done(() => {
        shippingOptionsComputeSuccess();
    });
}

export default shippingOptionsComputeRequest;